export default "__VITE_ASSET__BNJPhd91__"